import { List } from 'immutable';

export function nPublishersByVisitors(categorizedPublishers, n) {
  return getPublishersByVisitors(categorizedPublishers).slice(0, n);
}

export function visitorsSum(publishers){
  return publishers.reduce((total, el) => total + el.get('site_unique_users'), 0);
}

export function getPublishersByVisitors(categorizedPublishers) {
  if (!categorizedPublishers){
    return [];
  }

  const categories = ['targeted', 'industry_specific', 'local', 'national', 'global', 'social'];

  let publishersList = new List();
  categories.forEach(category => {
    if (categorizedPublishers.has(category) && !categorizedPublishers.get(category).isEmpty()) {
      publishersList = publishersList.concat(categorizedPublishers.get(category));
    }
  });

  return publishersList.sortBy(publisher => {
    return publisher.get('site_unique_users');
  }).reverse();
}



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/lib/parsePublishers.js